export const ru = {
    // Общие
  common: {
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    close: 'Закрыть',
    back: 'Назад',
    previous: 'Предыдущая',
    next: 'Следующая',
    search: 'Поиск',
    filter: 'Фильтр',
    all: 'Все',
    yes: 'Да',
    no: 'Нет',
    confirm: 'Подтвердить',
    success: 'Успешно',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    create: 'Создать',
    update: 'Обновить',
    creating: 'Создание...',
    updating: 'Обновление...',
    saving: 'Сохранение...',
    deleting: 'Удаление...',
    select: 'Выберите...',
    selectClient: 'Выберите клиента',
    selectBankAccount: 'Выберите банковский счет',
    noResults: 'Ничего не найдено',
    adding: 'Добавление...',
    filters: 'Фильтры',
    clear: 'Очистить',
    period: 'Период',
    from: 'С',
    to: 'По',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    activeFilters: 'Активные фильтры',
    collapse: 'Свернуть',
    expand: 'Развернуть',
    selectPeriod: 'Выберите период',
    apply: 'Применить',
    clearFilters: 'Очистить фильтры',
    actions: 'Действия',
    copy: 'Копировать',
    viewAll: 'Смотреть все',
    bankName: 'Название банка',
    accountNumber: 'Номер счета',
    currency: 'Валюта',
    balance: 'Баланс',
    bankAccounts: {
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    editAccount: 'Редактировать банковский счет',
    deleteAccountConfirm: 'Вы уверены, что хотите удалить этот банковский счет?',
    comingSoon: 'Скоро'
  },

  // Навигация
  nav: {
    companies: 'Мои компании',
    invoices: 'Инвойсы',
    transactions: 'Транзакции',
    logout: 'Выйти из системы'
  },

  // Аутентификация
  auth: {
    login: 'Войти',
    register: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    loginButton: 'Войти в систему',
    registerButton: 'Зарегистрироваться',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    noAccount: 'Нет аккаунта?',
    switchToLogin: 'Войти',
    switchToRegister: 'Зарегистрироваться',
    logoutConfirm: 'Вы уверены, что хотите выйти из системы?',
    error: 'Ошибка авторизации',
    registrationSuccess: 'Регистрация прошла успешно! Теперь вы можете войти в систему.',
    passwordsDoNotMatch: 'Пароли не совпадают',
    emailRequired: 'Email обязателен',
    passwordRequired: 'Пароль обязателен',
    passwordMinLength: 'Пароль должен содержать минимум 6 символов',
    activation: {
      title: 'Активация аккаунта',
      subtitle: 'Приветствуем',
      description: 'Установите пароль для завершения активации аккаунта',
      activate: 'Активировать аккаунт',
      activating: 'Активация...',
      invalidToken: 'Недействительная ссылка активации',
      tokenExpired: 'Ссылка активации недействительна или истекла срок действия.',
      alreadyActivated: 'Аккаунт уже активирован',
      alreadyActivatedMessage: 'Ваш аккаунт уже активирован. Вы можете войти в систему.'
    }
  },

  // Компании
  companies: {
    title: 'Мои компании',
    createCompany: 'Создать компанию',
    addCompany: 'Добавить компанию',
    companyName: 'Название компании',
    taxId: 'ИНН/Registration Number',
    vatId: 'VAT ID',
    address: 'Адрес',
    phone: 'Телефон',
    email: 'Email',
    website: 'Веб-сайт',
    logoPath: 'Логотип компании',
    currentLogo: 'Текущий логотип',
    country: 'Страна',
    city: 'Город',
    companyAddress: 'Адрес компании',
    createDescription: 'Заполните информацию о вашей компании',
    editDescription: 'Обновите информацию о компании',
    logoSupport: 'Поддерживаемые форматы: PNG, JPG, JPEG, SVG. Максимальный размер: 2MB',
    uploading: 'Загрузка...',
    upload: 'Загрузить',
    deleteLogo: 'Удалить логотип',
    deleteLogoConfirm: 'Вы уверены, что хотите удалить логотип компании?',
    deleteLogoError: 'Ошибка при удалении логотипа',
    saving: 'Сохранение...',
    deleting: 'Удаление...',
    create: 'Создать',
    save: 'Сохранить',
    cancel: 'Отмена',
    companyNamePlaceholder: 'ООО Рога и Копыта',
    taxIdPlaceholder: 'ΗΕ 446327 или 1234567890',
    vatIdPlaceholder: '60009782N',
    phonePlaceholder: '+48 123 456 789',
    emailPlaceholder: 'info@company.com',
    websitePlaceholder: 'https://company.com',
    countryPlaceholder: 'Польша',
    cityPlaceholder: 'Варшава',
    addressPlaceholder: 'ул. Примерная, д. 1, оф. 123',
    chooseFile: 'Выбрать файл',
    noFileChosen: 'Файл не выбран',
    details: 'Детали',
    name: 'Название',
    bankAccount: 'Банковский счет',
    bankAccountName: 'Название счета',
    bankAccountNamePlaceholder: 'Например: Основной счет',
    accountNumber: 'Номер счета',
    bankName: 'Название банка',
    bankAccounts: {
      title: 'Банковские счета',
      addAccount: 'Добавить счет',
      accountNumber: 'Номер счета',
      bankName: 'Название банка',
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    correspondentAccount: 'Корреспондентский счет',
    correspondentBank: 'Корреспондентский банк',
    bankAddress: 'Адрес банка',
    currency: 'Валюта',
    balance: 'Баланс',
    editAccount: 'Редактировать банковский счет',
    deleteAccountConfirm: 'Вы уверены, что хотите удалить этот банковский счет?',
    // Табы
    tabs: {
      overview: 'Обзор',
      accounts: 'Счета',
      invoices: 'Инвойсы',
      expenses: 'Расходы',
      contracts: 'Контракты',
      counterparties: 'Контрагенты',
      bankTransactions: 'Банковские транзакции',
      invoiceNumbering: 'Настройки нумерации',
      correctionInvoiceNumbering: 'Нумерация корректов',
      correctionInvoices: 'Корректировочные счета',
      users: 'Пользователи',
      settings: 'Настройки'
    },
    // Действия
    edit: 'Редактировать',
    backToList: 'Назад к списку',
    taxIdLabel: 'ИНН',
    // Табы - содержимое
    overview: {
      title: 'Основная информация',
      statistics: 'Статистика',
      name: 'Название',
      taxId: 'ИНН',
      address: 'Адрес',
      phone: 'Телефон',
      email: 'Email',
      website: 'Веб-сайт',
      bankAccountsCount: 'Банковских счетов',
      invoicesCount: 'Инвойсов (30 дней)',
      counterpartiesCount: 'Контрагентов',
      transactionsCount: 'Транзакций'
    },
    accounts: {
      title: 'Банковские счета',
      updateError: 'Ошибка при обновлении счета',
      deleteError: 'Ошибка при удалении счета',
      addAccount: 'Добавить счет',
      addFirstAccount: 'Добавить первый счет',
      noAccounts: 'У компании пока нет банковских счетов',
      accountNumber: 'Счет',
      balance: 'Баланс',
      edit: 'Редактировать',
      addAccountError: 'Ошибка при добавлении банковского счета'
    },
    invoices: {
      title: 'Инвойсы',
      createInvoice: 'Создать инвойс',
      createFirstInvoice: 'Создать первый инвойс',
      searchPlaceholder: 'Поиск инвойсов...',
      allStatuses: 'Все статусы',
      noInvoices: 'У компании пока нет инвойсов',
      noInvoicesFound: 'Инвойсы не найдены',
      allInvoicesLoaded: 'Все инвойсы загружены',
      totalInvoices: 'Всего инвойсов',
      clearFilters: 'Очистить фильтры',
      loading: 'Загрузка инвойсов...',
      client: 'Клиент',
      date: 'Дата',
      dueDate: 'Срок',
      details: 'Детали',
      viewPdf: 'Просмотр PDF',
      downloadPdf: 'Скачать PDF',
      edit: 'Редактировать',
      viewDetails: 'Просмотр деталей',
      download: 'Скачать',
      copy: 'Копировать',
      changeStatus: 'Изменить статус',
      statuses: {
        DRAFT: 'Черновик',
        SENT: 'Отправлен',
        PARTIALLY_PAID: 'Частично оплачен',
        PAID: 'Оплачен',
        OVERDUE: 'Просрочен',
        CANCELLED: 'Отменен'
      },
      cannotEditNonDraft: 'Эта фактура не может быть отредактирована, так как её статус отличен от "Черновик". Можно изменить только статус фактуры.',
      cannotChangeToDraft: 'Нельзя изменить статус фактуры на "Черновик", если она уже была отправлена.',
      paymentMethod: 'Способ оплаты',
      // Импорт инвойсов
      importInvoice: 'Импорт инвойса',
      selectPdfFile: 'Выберите PDF файл',
      parsedData: 'Распознанные данные',
      invoiceNumber: 'Номер инвойса',
      issueDate: 'Дата выпуска',
      totalAmount: 'Общая сумма',
      buyerName: 'Покупатель',
      clientFound: 'Клиент найден',
      clientNotFound: 'Клиент не найден',
      parsingFailed: 'Ошибка распознавания',
      importing: 'Импорт...',
      creating: 'Создание...',
      invoiceCreated: 'Инвойс успешно создан',
      errorCreatingInvoice: 'Ошибка создания инвойса',
      sendAllDrafts: 'Отправить все черновики',
      sendAllDraftsConfirm: 'Отправить все фактуры со статусом "Черновик" по очереди (по дате выставления)?',
      sendAllDraftsInProgress: 'Идет отправка...',
      sendAllDraftsProgress: 'Обработка фактур',
      sendAllDraftsDone: 'Готово',
      sendAllDraftsNoDrafts: 'Нет фактур со статусом "Черновик"',
      sendAllDraftsFailed: 'Процесс остановлен из-за ошибки',
      import: 'Импортировать',
      bulkImport: 'Массовый импорт инвойсов',
      selectPdfFiles: 'Выберите PDF файлы (можно несколько)',
      createCounterparty: 'Создать контрагента',
      createInvoiceFromParsed: 'Создать инвойс',
      counterpartyCreated: 'Контрагент успешно создан',
      errorCreatingCounterparty: 'Ошибка создания контрагента'
    },
    expenses: {
      add: 'Добавить расход',
      edit: 'Редактировать расход',
      deleteConfirm: 'Удалить этот расход?',
      search: 'Поиск по номеру, названию, контрагенту...',
      total: 'Всего',
      empty: 'Расходы не найдены',
      number: 'Номер',
      title: 'Название',
      counterparty: 'Контрагент',
      date: 'Дата',
      amount: 'Сумма',
      status: 'Статус',
      file: 'Файл',
      uploadFile: 'Загрузить',
      allCounterparties: 'Все контрагенты',
      fileTypeError: 'Разрешены только PDF, PNG, JPG, JPEG',
      fileSizeError: 'Размер файла не должен превышать 10MB',
      netAmount: 'Сумма нетто',
      taxAmount: 'Сумма налога',
      grossAmount: 'Сумма брутто',
      category: 'Категория',
      notes: 'Заметки',
      issueDate: 'Дата документа',
      dueDate: 'Срок оплаты',
      paymentDate: 'Дата оплаты',
      noCounterparties: 'Нет контрагентов',
      statuses: {
        NEW: 'Новый',
        APPROVED: 'Подтвержден',
        PAID: 'Оплачен',
        CANCELLED: 'Отменен'
      }
    },
    contracts: {
      add: 'Добавить контракт',
      edit: 'Редактировать контракт',
      deleteConfirm: 'Удалить этот контракт?',
      search: 'Поиск по номеру, названию, контрагенту...',
      total: 'Всего',
      empty: 'Контракты не найдены',
      number: 'Номер',
      title: 'Название',
      counterparty: 'Контрагент',
      period: 'Период',
      status: 'Статус',
      file: 'Файл',
      uploadFile: 'Загрузить',
      allCounterparties: 'Все контрагенты',
      fileTypeError: 'Разрешены только PDF, PNG, JPG, JPEG',
      fileSizeError: 'Размер файла не должен превышать 10MB',
      valueAmount: 'Сумма контракта',
      notes: 'Заметки',
      startDate: 'Дата начала',
      endDate: 'Дата окончания',
      noCounterparties: 'Нет контрагентов',
      statuses: {
        DRAFT: 'Черновик',
        ACTIVE: 'Активный',
        EXPIRED: 'Истек',
        TERMINATED: 'Расторгнут'
      }
    },
      counterparties: {
        title: 'Контрагенты',
        addCounterparty: 'Добавить контрагента',
        addFirstCounterparty: 'Добавить первого контрагента',
        searchPlaceholder: 'Поиск контрагентов...',
        noCounterparties: 'У компании пока нет контрагентов',
        noCounterpartiesFound: 'Контрагенты не найдены',
        city: 'Город',
        comment: 'Комментарий',
        clearSearch: 'Очистить поиск',
        loading: 'Загрузка контрагентов...',
        taxId: 'ИНН',
        vatId: 'VAT',
        contact: 'Контакт',
        email: 'Email',
        phone: 'Телефон',
        address: 'Адрес',
        edit: 'Редактировать',
        delete: 'Удалить',
        deleteConfirm: 'Вы уверены, что хотите удалить контрагента',
        syncStatus: {
          synced: 'Синхронизирован',
          notSynced: 'Не синхронизирован',
          noSync: 'Нет синхронизации'
        },
        syncConfirmTitle: 'Синхронизация с wFirma',
        syncConfirm: 'Создать контрагента "{name}" в wFirma?',
        syncInProgress: 'Синхронизация...',
        syncInProgressMessage: 'Пожалуйста, подождите, идет синхронизация контрагента с wFirma',
        syncSuccessTitle: 'Синхронизация успешна',
        syncSuccess: 'Контрагент успешно синхронизирован с wFirma',
        syncErrorTitle: 'Ошибка синхронизации',
        syncError: 'Произошла ошибка при синхронизации контрагента с wFirma',
        syncClickHint: 'Нажмите для синхронизации с wFirma',
        unsyncAll: 'Отвязать от wFirma',
        unsyncAllHint: 'Сбросить привязку у всех контрагентов (для перепривязки к новой wFirma)',
        unsyncAllConfirm: 'Сбросить привязку к wFirma у всех контрагентов? После этого можно будет заново синхронизировать с новой учётной записью wFirma.',
        unsyncAllSuccess: 'Привязка сброшена',
        syncAll: 'Синхр. в wFirma',
        syncAllHint: 'Добавить всех контрагентов в wFirma',
        syncAllSuccess: 'Все контрагенты синхронизированы'
      },
    users: {
      title: 'Пользователи компании',
      addUser: 'Добавить пользователя',
      email: 'Email',
      role: 'Роль',
      noUsers: 'Пользователи не найдены',
      noUsersFound: 'Пользователи не найдены',
      confirmRemove: 'Вы уверены, что хотите удалить этого пользователя?',
      searchUser: 'Email пользователя',
      searchPlaceholder: 'Введите email...',
      selectedUser: 'Выбран',
      emailHint: 'Можно добавить существующего пользователя или создать нового',
      status: 'Статус',
      activated: 'Активирован',
      notActivated: 'Не активирован',
      linkCopied: 'Ссылка скопирована в буфер обмена',
      cannotRemoveSelf: 'Нельзя удалить себя',
      accessDenied: 'Доступ ограничен',
      onlyAdminAccess: 'Только администратор компании имеет доступ к управлению пользователями.',
      roles: {
        ADMIN: 'Администратор',
        EMPLOYEE: 'Сотрудник',
        VIEWER: 'Просмотр'
      }
    },
    import: {
      import: 'Импорт',
      importing: 'Импорт...',
      downloadTemplate: 'Скачать шаблон',
      selectFile: 'Выбрать файл',
      selectedFile: 'Выбран файл',
      imported: 'Импортировано',
      errors: 'Ошибки',
      selectSource: 'Выберите источник импорта',
      fromFile: 'Импорт из файла',
      fromFileDescription: 'CSV или Excel файл',
      fromWFirma: 'Импорт из wFirma',
      fromWFirmaDescription: 'Импорт всех контрагентов из wFirma',
      wfirmaNotConfigured: 'Сначала настройте интеграцию wFirma в настройках компании',
      wfirmaImportDescription: 'Импортирует все контрагенты из wFirma. Существующие контрагенты будут обновлены.',
      created: 'Создано',
      updated: 'Обновлено',
      skipped: 'Пропущено',
      counterparties: {
        title: 'Импорт контрагентов'
      },
      bankAccounts: {
        title: 'Импорт банковских счетов'
      }
    },
    transactions: {
      title: 'Транзакции',
      addTransaction: 'Добавить транзакцию',
      addFirstTransaction: 'Добавить первую транзакцию',
      noTransactions: 'У компании пока нет транзакций'
    },
    bankTransactions: {
      title: 'Банковские транзакции',
      importCsv: 'Импорт CSV',
      autoMatch: 'Автосопоставление',
      matching: 'Сопоставление...',
      loading: 'Загрузка транзакций...',
      totalTransactions: 'Всего транзакций',
      matchedTransactions: 'Сопоставлено',
      unmatchedTransactions: 'Не сопоставлено',
      matchingRate: 'Процент сопоставления',
      unmatchConfirm: 'Вы уверены, что хотите отменить сопоставление транзакции?',
      deleteConfirm: 'Вы уверены, что хотите удалить транзакцию?',
      // Таблица
      table: {
        date: 'Дата',
        description: 'Описание',
        type: 'Тип',
        amount: 'Сумма',
        status: 'Статус',
        actions: 'Действия',
        noTransactions: 'Транзакции не найдены'
      },
      // Статусы
      status: {
        matched: 'Сопоставлена',
        unmatched: 'Не сопоставлена'
      },
      // Типы транзакций
      types: {
        INCOME: 'Доход',
        EXPENSE: 'Расход'
      },
      // Действия
      actions: {
        match: 'Сопоставить',
        unmatch: 'Отменить сопоставление',
        delete: 'Удалить'
      },
      // Фильтры
      allAccounts: 'Все счета',
      transactionType: 'Тип транзакции',
      allTypes: 'Все типы',
      income: 'Доходы',
      expense: 'Расходы',
      category: 'Категория',
      allCategories: 'Все категории',
      searchPlaceholder: 'Поиск по описанию, контрагенту...',
      type: 'Тип',
      // Пагинация
      pagination: {
        showing: 'Показано {{count}} из {{total}} транзакций'
      }
    }
  },

  // Инвойсы
  invoices: {
    title: 'Инвойсы',
    createInvoice: 'Создать инвойс',
    invoiceNumber: 'Номер инвойса',
    clientId: 'Клиент',
    issueDate: 'Дата выставления',
    dueDate: 'Срок оплаты',
    saleDate: 'Дата продажи',
    placeOfIssue: 'Место выставления',
    invoiceType: 'Тип фактуры',
    exchangeRate: 'Курс валют',
    exchangeRateTable: 'Таблица курсов',
    exchangeRateDate: 'Дата курса',
    reverseCharge: 'Обратное обложение НДС',
    status: 'Статус',
    paymentMethod: 'Способ оплаты',
    pdfLanguage: 'Язык фактуры',
    notes: 'Примечания',
    notesPlaceholder: 'Дополнительная информация...',
    internalComment: 'Комментарий',
    internalCommentPlaceholder: 'Внутренний комментарий (не отображается в фактуре)...',
    internalCommentHint: 'Этот комментарий виден только вам и не будет отображаться в PDF фактуре',
    basicInfo: 'Основная информация',
    selectFile: 'Выбрать файл',
    parseFile: 'Обработать файл',
    chooseFile: 'Выбрать файл',
    noFileChosen: 'Файл не выбран',
    duplicateInvoice: 'Инвойс уже существует',
    duplicateInvoiceMessage: 'Инвойс с таким номером уже существует. Что вы хотите сделать?',
    saveWithNewNumber: 'Сохранить с новым номером',
    cancelImport: 'Отменить импорт',
    editInvoiceNumber: 'Изменить номер инвойса',
    items: 'Позиции',
    descriptionPlaceholder: 'Описание услуги/товара',
    addItem: 'Добавить позицию',
    description: 'Описание',
    quantity: 'Количество',
    unitPrice: 'Цена за единицу',
    unitOfMeasure: 'Единица измерения',
    unitOfMeasures: {
      PIECE: 'шт.',
      HOUR: 'час',
      DAY: 'день', 
      WEEK: 'неделя',
      MONTH: 'месяц',
      KG: 'кг',
      TON: 'т',
      METER: 'м',
      SQUARE_METER: 'м²',
      CUBIC_METER: 'м³',
      LITER: 'л',
      SET: 'компл.'
    },
    taxRate: 'НДС %',
    total: 'Сумма',
    subtotal: 'Сумма без налога',
    taxAmount: 'Сумма налога',
    grandTotal: 'ИТОГО',
    editInvoice: 'Редактировать инвойс',
    deleteInvoiceConfirm: 'Вы уверены, что хотите удалить этот инвойс?',
    viewPdf: 'Просмотр PDF',
    downloadPdf: 'Скачать PDF',
    download: 'Скачать',
    copy: 'Копировать',
    copyInvoice: 'Копировать инвойс',
    create: 'Создать',
    createError: 'Ошибка создания инвойса',
    importError: 'Ошибка импорта инвойса',
    pdfViewer: {
      title: 'Просмотр инвойса',
      language: 'Язык',
      download: 'Скачать PDF',
      downloading: 'Скачивание...',
      close: 'Закрыть',
      loading: 'Загрузка PDF...',
      notLoaded: 'PDF не загружен',
      loadPdf: 'Загрузить PDF'
    },
    currency: 'Валюта',
    currencies: {
      USD: 'USD - Доллар США',
      EUR: 'EUR - Евро',
      GBP: 'GBP - Британский фунт',
      CNY: 'CNY - Китайский юань',
      CAD: 'CAD - Канадский доллар',
      PLN: 'PLN - Польский злотый'
    },
    statuses: {
      DRAFT: 'Черновик',
      SENT: 'Отправлен',
      PARTIALLY_PAID: 'Частично оплачен',
      PAID: 'Оплачен',
      OVERDUE: 'Просрочен',
      CANCELLED: 'Отменен'
    },
    wfirma: {
      sendConfirmTitle: 'Отправка фактуры в wFirma',
      sendConfirm: 'Отправить фактуру "{number}" в wFirma?',
      alreadySyncedPrompt: 'Фактура уже была отправлена в wFirma. Отправить как новую фактуру?',
      sendExistingLink: 'Отправить без создания новой',
      sendAsNew: 'Отправить как новую',
      syncing: 'Отправка в wFirma...',
      syncingMessage: 'Пожалуйста, подождите, идет отправка фактуры в wFirma',
      sendSuccessTitle: 'Фактура отправлена',
      sendSuccess: 'Фактура успешно отправлена в wFirma',
      sendErrorTitle: 'Ошибка отправки',
      sendError: 'Произошла ошибка при отправке фактуры в wFirma',
      syncCounterpartyRequired: 'Требуется синхронизация контрагента',
      syncCounterpartyMessage: 'Контрагент "{name}" не синхронизирован с wFirma. Необходимо синхронизировать контрагента перед отправкой фактуры.',
      syncCounterparty: 'Синхронизировать контрагента',
      selectVatCodes: 'Выберите VAT коды',
      selectVatCodesMessage: 'Для некоторых позиций не найдены VAT коды. Пожалуйста, выберите подходящие коды:'
    },
    types: {
      STANDARD: 'Фактура',
      PROFORMA: 'Перформа инвойс',
      STANDARD_NO_VAT: 'Фактура без VAT',
      PROFORMA_NO_VAT: 'Проформа без VAT'
    },
    paymentMethods: {
      BANK_TRANSFER: 'Банковский перевод',
      CASH: 'Наличные'
    },
    units: {
      PIECE: 'шт.',
      HOUR: 'час',
      DAY: 'день',
      WEEK: 'неделя',
      MONTH: 'месяц',
      KG: 'кг',
      TON: 'т',
      METER: 'м',
      SQUARE_METER: 'м²',
      CUBIC_METER: 'м³',
      LITER: 'л',
      SET: 'компл.'
    },
    // Многошаговая форма
    multiStep: {
      basicInfo: 'Основная информация',
      items: 'Позиции инвойса',
      currency: 'Курс валют',
      review: 'Проверка',
      next: 'Далее',
      back: 'Назад',
      addItem: 'Добавить позицию'
    },
    // Импорт
    import: {
      title: 'Импорт инвойса',
      uploadTitle: 'Загрузка файла инвойса',
      dragAndDrop: 'Перетащите PDF файл сюда или нажмите для выбора',
      selectFile: 'Выбрать PDF файл',
      uploading: 'Загрузка...',
      parsing: 'Обработка...',
      fileSelected: 'Файл выбран',
      createCounterparty: 'Создание контрагента',
      createBankAccount: 'Создание банковского счета',
      createInvoice: 'Создание инвойса',
      counterpartyInfo: 'Информация о контрагенте',
      bankAccountInfo: 'Информация о банковском счете',
      invoiceInfo: 'Информация об инвойсе',
      invoiceItems: 'Позиции инвойса',
      editableItems: 'Вы можете отредактировать позиции инвойса ниже:',
      calculatedTotal: 'Рассчитанная сумма',
      skipStep: 'Пропустить шаг',
      useExisting: 'Использовать существующий',
      prefilledData: 'Данные предзаполнены из загруженного инвойса. Вы можете отредактировать любое поле перед созданием.',
      steps: {
        upload: 'Загрузка файла',
        counterparty: 'Контрагент',
        bankAccount: 'Банковский счет',
        invoice: 'Инвойс'
      }
    },
    // Валютные курсы
    exchangeRates: {
      title: 'Выбор курса валют',
      description: 'Для расчета НДС в польских злотых необходимо выбрать курс валюты',
      forDate: 'на дату, предшествующую дате выставления счета',
      autoSelected: 'Автоматически выбран курс на ближайшую доступную дату до даты выставления. Вы можете изменить выбор ниже.',
      selectRate: 'Выберите курс валюты',
      rateInfo: 'Информация о курсе',
      date: 'Дата',
      rate: 'Курс',
      table: 'Таблица',
      showFields: 'Показать поля курса валют',
      vatInPln: 'НДС в PLN',
      willBeRequired: 'На следующем шаге необходимо будет выбрать курс валют для расчета НДС в PLN.',
      selectRateRequired: 'Пожалуйста, выберите курс валют',
      loading: 'Загрузка курсов валют...',
      noRates: 'Курсы валют не найдены для выбранной даты. Пожалуйста, добавьте курс валют вручную.',
      pleaseSelect: 'Пожалуйста, выберите курс валют из списка ниже.',
      loadRates: 'Загрузить актуальные курсы валют',
      loadError: 'Не удалось загрузить курсы валют. Пожалуйста, попробуйте позже.'
    },
    // Ревью
    reviewStep: {
      title: 'Проверка данных',
      invoiceNumber: 'Номер инвойса',
      client: 'Клиент',
      invoiceType: 'Тип инвойса',
      currency: 'Валюта',
      issueDate: 'Дата выставления',
      dueDays: 'Срок оплаты',
      days: 'дней',
      exchangeRateInfo: 'Курс валюты',
      rateDate: 'Дата курса',
      positions: 'Позиции',
      notSelected: 'Не выбран'
    },
    // Ошибки валидации
    validation: {
      required: 'Обязательно для заполнения',
      invoiceNumberRequired: 'Номер инвойса обязателен',
      clientRequired: 'Клиент обязателен',
      invoiceTypeRequired: 'Тип инвойса обязателен',
      currencyRequired: 'Валюта обязательна',
      issueDateRequired: 'Дата выставления обязательна',
      dueDaysRequired: 'Срок оплаты обязателен',
      dueDaysMin: 'Срок должен быть больше 0 дней',
      bankAccountRequired: 'Банковский счет обязателен',
      accountNumberRequired: 'Номер счета обязателен',
      bankAccountNameRequired: 'Название счета обязательно',
      bankNameRequired: 'Название банка обязательно',
      balanceNonNegative: 'Баланс не может быть отрицательным',
      placeOfIssueRequired: 'Место выставления обязательно',
      descriptionRequired: 'Описание обязательно',
      quantityRequired: 'Количество обязательно',
      quantityMin: 'Количество должно быть больше 0',
      unitPriceRequired: 'Цена обязательна',
      unitPriceMin: 'Цена должна быть больше 0',
      companyNameRequired: 'Название компании обязательно',
      taxIdRequired: 'ИНН/Registration Number обязателен',
      taxIdMinLength: 'Минимум 3 символа',
      taxIdMaxLength: 'Максимум 20 символов',
      vatIdMaxLength: 'Максимум 20 символов',
      emailInvalid: 'Введите корректный email',
      cityRequired: 'Город обязателен для заполнения',
      fileValidationError: 'Ошибка валидации файла',
      logoUploadError: 'Ошибка загрузки логотипа',
      fillRequiredFields: 'Пожалуйста, заполните все обязательные поля'
    }
  },

  // Контрагенты
  counterparties: {
    title: 'Контрагенты',
    createCounterparty: 'Создать контрагента',
    counterpartyName: 'Название контрагента',
    contactPerson: 'Контактное лицо',
    addCounterparty: 'Добавить контрагента'
  },

  // Транзакции
  transactions: {
    title: 'Банковские транзакции',
    noTransactionsFound: 'Транзакции не найдены',
    createTransaction: 'Добавить транзакцию',
    import: {
      title: 'Импорт транзакций',
      bankAccount: 'Банковский счет',
      selectFile: 'Выберите файл',
      selectFiles: 'Выберите файлы',
      selectedFiles: 'Выбранные файлы',
      singleFile: 'Одиночный файл',
      multipleFiles: 'Множественный импорт',
      import: 'Импортировать',
      importing: 'Импорт...',
      supportedFormats: 'Поддерживаемые форматы: CSV, TXT, PDF'
    },
    table: {
      date: 'Дата',
      description: 'Описание',
      counterparty: 'Контрагент',
      amount: 'Сумма',
      type: 'Тип',
      currency: 'Валюта',
      status: 'Статус',
      actions: 'Действия'
    },
    statuses: {
      matched: 'Сопоставлена',
      unmatched: 'Не сопоставлена',
      income: 'Доход',
      expense: 'Расход'
    },
    actions: {
      match: 'Сопоставить',
      unmatch: 'Отменить сопоставление'
    },
    matching: {
      title: 'Сопоставление транзакции',
      transactionInfo: 'Информация о транзакции',
      selectInvoice: 'Выберите инвойс',
      selectInvoicePlaceholder: 'Выберите инвойс для сопоставления',
      match: 'Сопоставить',
      matching: 'Сопоставление...'
    }
  },

  // Языки
  languages: {
    title: 'Язык интерфейса',
    polishOnly: 'Polski',
    polishEnglish: 'Polski-English',
    english: 'English'
  },

  // Валюты
  currencies: {
    USD: 'USD - Доллар США',
    EUR: 'EUR - Евро',
    CNY: 'CNY - Китайский юань',
    GBP: 'GBP - Фунт стерлингов',
    CAD: 'CAD - Канадский доллар',
    PLN: 'PLN - Польский злотый'
  },

  // Контрагенты
  counterparty: {
    addTitle: 'Добавить контрагента',
    editTitle: 'Редактировать контрагента',
    name: 'Название',
    nameRequired: 'Название обязательно',
    namePlaceholder: 'ООО Контрагент',
    taxId: 'ИНН',
    taxIdPlaceholder: '123456789012',
    vatId: 'VAT',
    vatIdPlaceholder: 'VAT123456789',
    address: 'Адрес',
    addressPlaceholder: 'Москва, ул. Примерная, 1',
    contactPerson: 'Контактное лицо',
    contactPersonPlaceholder: 'Иван Иванов',
    email: 'Email',
    emailPlaceholder: 'contact@company.ru',
    phone: 'Телефон',
    phonePlaceholder: '+7-999-123-45-67',
    country: 'Страна',
    countryPlaceholder: 'Польша',
    city: 'Город',
    cityPlaceholder: 'Варшава',
    comment: 'Комментарий',
    commentPlaceholder: 'Введите комментарий...',
    createError: 'Ошибка создания контрагента',
    wfirmaSync: 'Синхронизация с wFirma',
    wfirmaId: 'ID в wFirma',
    removeSync: 'Удалить синхронизацию',
    unsyncConfirm: 'Вы уверены, что хотите удалить синхронизацию с wFirma? После этого можно будет заново синхронизировать контрагента.',
    wfirmaSyncHint: 'После удаления синхронизации можно будет заново синхронизировать контрагента',
    details: {
      title: 'Информация о контрагенте',
      notFound: 'Контрагент не найден',
      invoicesTitle: 'Инвойсы контрагента',
      loadingInvoices: 'Загрузка инвойсов...',
      noInvoices: 'Инвойсы не найдены'
    }
  },

  // Корректировочные счета
  correctionInvoices: {
    title: 'Корректировочные счета-фактуры',
    manageCorrections: 'Управление корректировками',
    description: 'Перейдите на страницу управления корректировочными счетами для создания и просмотра корректировок.',
    createCorrection: 'Создать корректировку',
    viewCorrections: 'Просмотр корректировок',
    noCorrectionsFound: 'Корректировочные счета не найдены',
    tryAgain: 'Попробовать снова',
    statuses: {
      DRAFT: 'Черновик',
      SENT: 'Отправлен',
      ACCEPTED: 'Принят',
      REJECTED: 'Отклонен'
    },
    types: {
      CORRECTION: 'Исправление',
      CANCELLATION: 'Аннулирование',
      REPLACEMENT: 'Замена'
    },
    tableHeaders: {
      number: 'Номер',
      date: 'Дата',
      type: 'Тип',
      status: 'Статус',
      difference: 'Разность',
      reason: 'Причина',
      actions: 'Действия'
    },
    statusOptions: {
      send: 'Отправить',
      accept: 'Принять',
      reject: 'Отклонить'
    },
    delete: 'Удалить',
    deleteConfirm: 'Вы уверены, что хотите удалить этот корректировочный счет?',
    pagination: {
      showing: 'Показано',
      of: 'из',
      records: 'записей'
    },
    errors: {
      updateStatus: 'Ошибка при обновлении статуса',
      deleteError: 'Ошибка при удалении корректировочного счета',
      downloadError: 'Ошибка при скачивании PDF'
    },
    modal: {
      title: 'Создать корректировочный счет-фактуру',
      originalInvoice: 'Оригинальный счет',
      selectOriginalInvoice: 'Выберите оригинальный счет',
      searchInvoice: 'Поиск по номеру счета...',
      noInvoicesFound: 'Счета не найдены',
      correctionNumber: 'Номер корректировки',
      correctionDate: 'Дата корректировки',
      reason: 'Причина корректировки',
      reasonPlaceholder: 'Опишите причину корректировки',
      correctionType: 'Тип корректировки',
      items: 'Позиции',
      addItem: 'Добавить позицию',
      removeItem: 'Удалить позицию',
      description: 'Описание',
      unitOfMeasure: 'Единица измерения',
      originalQuantity: 'Оригинальное количество',
      originalUnitPrice: 'Оригинальная цена за единицу',
      originalTotalPrice: 'Оригинальная общая цена',
      originalTaxRate: 'Оригинальная ставка НДС',
      originalTaxAmount: 'Оригинальная сумма НДС',
      correctedQuantity: 'Скорректированное количество',
      correctedUnitPrice: 'Скорректированная цена за единицу',
      correctedTotalPrice: 'Скорректированная общая цена',
      correctedTaxRate: 'Скорректированная ставка НДС',
      correctedTaxAmount: 'Скорректированная сумма НДС',
      save: 'Сохранить',
      cancel: 'Отмена',
      saving: 'Сохранение...',
      loading: 'Загрузка...',
      error: 'Ошибка при создании корректировки',
      loadError: 'Ошибка при загрузке оригинального счета',
      createError: 'Ошибка при создании корректировочного счета',
      // Сообщения валидации
      required: 'обязателен',
      requiredF: 'обязательна',
      // Заголовки колонок таблицы позиций (короткие версии для UI)
      originalPrice: 'Ориг. цена',
      correctedPrice: 'Корр. цена',
      originalAmount: 'Ориг. сумма',
      correctedAmount: 'Корр. сумма',
      difference: 'Разность',
      remove: 'Удалить'
    }
  },
  invoiceNumbering: {
    title: 'Настройки нумерации фактур',
    template: 'Шаблон нумерации',
    templateDescription: {
      NN_MM_YYYY: 'Порядковый номер/месяц/год (например: 01/09/2025)',
      NN_YYYY: 'Порядковый номер/год (например: 01/2025)',
      NN_MM_YYYY_ID: 'Порядковый номер/месяц/год/суффикс (например: 01/09/2025/ABC)'
    },
    suffix: 'Суффикс',
    suffixPlaceholder: 'Введите суффикс (например: ABC, 2025)',
    currentSequence: 'Текущий порядковый номер',
    nextNumber: 'Следующий номер фактуры будет: {number}',
    preview: 'Предварительный просмотр',
    save: 'Сохранить',
    saving: 'Сохранение...',
    loadError: 'Ошибка при загрузке настроек',
    saveError: 'Ошибка при сохранении настроек',
    generateNew: 'Сгенерировать новый номер',
    generateNewTooltip: 'Сгенерировать новый номер'
  },
  correctionInvoiceNumbering: {
    title: 'Настройки нумерации корректировочных счетов',
    template: 'Шаблон нумерации',
    templateDescription: {
      NN_MM_YYYY: 'Порядковый номер/месяц/год (например: 01/09/2025)',
      NN_YYYY: 'Порядковый номер/год (например: 01/2025)',
      NN_MM_YYYY_ID: 'Порядковый номер/месяц/год/суффикс (например: 01/09/2025/KOR)'
    },
    suffix: 'Суффикс',
    suffixPlaceholder: 'Введите суффикс (например: KOR, ABC)',
    currentSequence: 'Текущий порядковый номер',
    nextNumber: 'Следующий номер корректировочного счета будет: {number}',
    preview: 'Предварительный просмотр',
    save: 'Сохранить',
    saving: 'Сохранение...',
    loadError: 'Ошибка при загрузке настроек',
    saveError: 'Ошибка при сохранении настроек',
    generateNew: 'Сгенерировать новый номер',
    generateNewTooltip: 'Сгенерировать новый номер'
  },
  settings: {
    sections: {
      invoiceNumbering: 'Нумерация фактур',
      correctionInvoiceNumbering: 'Нумерация корректировок',
      integrations: 'Интеграции',
      apiKeys: 'API keys'
    },
    apiKeys: {
      title: 'API keys (коннектор документов)',
      hint: 'Ключ даёт доступ к /api/connector/v1: контрагенты, приходы, контракты и выставленные фактуры (поиск, статус, оплата). Показывается один раз при создании.',
      name: 'Название',
      scopes: 'Scopes',
      create: 'Создать ключ',
      copyOnce: 'Скопируйте ключ сейчас — больше он не покажется:',
      active: 'Активные',
      empty: 'Нет ключей',
      revoke: 'Отозвать',
      revokeConfirm: 'Отозвать ключ?',
      revoked: 'Отозванные'
    }
  },
  integrations: {
    wfirma: {
      title: 'Интеграция wFirma',
      description: 'Настройте подключение к wFirma для синхронизации контрагентов',
      companyId: 'ID компании в wFirma',
      companyIdHint: 'ID вашей компании в системе wFirma',
      accessKey: 'Access Key',
      accessKeyPlaceholder: 'Введите Access Key',
      secretKey: 'Secret Key',
      secretKeyPlaceholder: 'Введите Secret Key',
      secretKeyHint: 'Отображается только один раз при создании',
      appKey: 'App Key',
      appKeyPlaceholder: 'Введите App Key',
      appKeyHint: 'Выдается wFirma.pl индивидуально для каждого приложения',
      loadError: 'Ошибка загрузки конфигурации',
      saveError: 'Ошибка сохранения конфигурации',
      saveSuccess: 'Конфигурация сохранена успешно',
      deleteError: 'Ошибка удаления конфигурации',
      deleteSuccess: 'Конфигурация удалена',
      deleteConfirm: 'Вы уверены, что хотите удалить конфигурацию wFirma?',
      fillAllFields: 'Заполните все поля',
      bulkInvoicesTitle: 'Отправка фактур в wFirma за период',
      bulkInvoicesHint:
        'Выберите период. Без «Повторная отправка» пропускаются уже синхронизированные фактуры. С включённой опцией старые привязки сбрасываются и фактуры создаются заново в wFirma.',
      periodFrom: 'С',
      periodTo: 'По',
      dateField: 'Период по',
      dateFieldIssue: 'Дата выставления',
      dateFieldSale: 'Дата продажи',
      forceResync: 'Повторная отправка (сбросить старую привязку wFirma)',
      sendPeriod: 'Отправить в wFirma',
      periodDatesRequired: 'Укажите даты начала и конца периода',
      resultTotal: 'В выборке',
      resultSuccess: 'Отправлено',
      resultSkipped: 'Пропущено (уже были в wFirma)',
      resultFailed: 'Ошибок',
      errorList: 'Список ошибок',
      resetInvoicesTitle: 'Сброс отправленных фактур в черновики',
      resetInvoicesHint:
        'Для фактур со статусом Отправлен за период будет выставлен статус Черновик и очищен wFirma ID. Это удобно перед ручной отправкой по одной фактуре.',
      resetToDraftButton: 'Сбросить в черновики',
      resetToDraftResult: 'Переведено в черновики',
      resetSkippedNotSent: 'Пропущено (статус не выбран)',
      resetStatusesLabel: 'Какие статусы сбрасывать',
      resetStatusesRequired: 'Выберите хотя бы один статус',
      resetConfirm: 'Перевести все отправленные фактуры за период обратно в черновики и очистить wFirma ID?',
      vatCodesTitle: 'Проверка VAT-кодов wFirma',
      vatCodesHint: 'Обновляет VAT-коды из текущего аккаунта wFirma и показывает базовую проверку ключевых ставок/кодов.',
      vatCodesRefreshButton: 'Обновить и проверить VAT-коды',
      vatCodesTotal: 'Всего VAT-кодов',
      vatCodesListTitle: 'Список VAT-кодов из wFirma',
      accounts: {
        title: 'Счета wFirma',
        description: 'Синхронизируйте и свяжите счета компании со счетами в wFirma',
        sync: 'Синхронизировать счета',
        syncSuccess: 'Счета успешно синхронизированы',
        syncError: 'Ошибка синхронизации счетов',
        autoMap: 'Автоматически связать',
        autoMapSuccess: 'Автоматически связано счетов',
        autoMapError: 'Ошибка автоматической связи',
        wfirmaAccounts: 'Счета в wFirma',
        noWFirmaAccounts: 'Нет синхронизированных счетов. Нажмите "Синхронизировать счета" для загрузки.',
        ourAccounts: 'Наши счета',
        noOurAccounts: 'Нет счетов компании',
        mappedTo: 'Связано с',
        selectWFirmaAccount: 'Выберите счет wFirma:',
        selectAccount: '-- Выберите счет --',
        noMatchingCurrency: 'Нет счетов wFirma с валютой',
        map: 'Связать',
        mapError: 'Ошибка связи счетов',
        unmap: 'Удалить связь',
        unmapConfirm: 'Вы уверены, что хотите удалить связь?',
        unmapError: 'Ошибка удаления связи'
      }
    }
  },
  wfirma: {
    accounts: {
      title: 'Счета wFirma',
      description: 'Синхронизируйте и свяжите счета компании со счетами в wFirma',
      sync: 'Синхронизировать счета',
      syncSuccess: 'Счета успешно синхронизированы',
      syncError: 'Ошибка синхронизации счетов',
      autoMap: 'Автоматически связать',
      autoMapSuccess: 'Автоматически связано счетов',
      autoMapError: 'Ошибка автоматической связи',
      wfirmaAccounts: 'Счета в wFirma',
      noWFirmaAccounts: 'Нет синхронизированных счетов. Нажмите "Синхронизировать счета" для загрузки.',
      ourAccounts: 'Наши счета',
      noOurAccounts: 'Нет счетов компании',
      mappedTo: 'Связано с',
      selectWFirmaAccount: 'Выберите счет wFirma:',
      selectLocalAccount: 'Выберите местный счет:',
      selectAccount: '-- Выберите счет --',
      noMatchingCurrency: 'Нет счетов wFirma с валютой',
      map: 'Связать',
      mapError: 'Ошибка связи счетов',
      unmap: 'Удалить связь',
      unmapConfirm: 'Вы уверены, что хотите удалить связь?',
      unmapError: 'Ошибка удаления связи',
      linkWFirmaAccount: 'Связать со счетом wFirma',
      selectWFirmaAccountForEdit: 'Выберите счет wFirma для связи',
      syncStatus: 'Статус wFirma',
      synchronized: 'Синхронизирован',
      notSynchronized: 'Нет',
      clearLocal: 'Удалить локальные счета wFirma',
      clearLocalHint:
        'После смены аккаунта wFirma удалите локальный кэш, затем синхронизируйте и при необходимости свяжите счета заново. В самой wFirma счета не удаляются.',
      clearLocalConfirm:
        'Удалить все локально сохранённые счета wFirma и связи с банковскими счетами? В wFirma ничего не удаляется. После этого нажмите «Синхронизировать счета».',
      clearLocalSuccess: 'Удалено записей',
      clearLocalError: 'Ошибка удаления локальных счетов wFirma'
    }
  }
};
